import { render } from "./chatComponent.vue?vue&type=template&id=8bbb3d78&scoped=true"
import script from "./chatComponent.vue?vue&type=script&lang=js"
export * from "./chatComponent.vue?vue&type=script&lang=js"

import "./chatComponent.vue?vue&type=style&index=0&id=8bbb3d78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bbb3d78"]])

export default __exports__